import { createBaseApi } from 'spraypaint-toolkit';

// change in .env or .env.production
export const url = import.meta.env.VITE_API_URL || 'http://192.168.40.11:3000';
// export const url = "http://192.168.40.11";
export const actioncablePath = '/cable';
export const apiPath = '/api/v1';
export const clientApplication = 'spitagram';

export const createApi = (params) =>
  createBaseApi({ url, apiPath, ...params, clientApplication });

export default createApi();
